var render = function render(_c,_vm){return _c('span',_vm._g({staticClass:"VCheckbox noselect",class:{'VCheckbox_active':_vm.props.checked,'VCheckbox_disabled':_vm.props.disabled}},_vm.listeners.click ? { click: _vm.listeners.click } : null))
}
var staticRenderFns = []

export { render, staticRenderFns }